/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StockManageListResVo } from './StockManageListResVo';
import {
    StockManageListResVoFromJSON,
    StockManageListResVoFromJSONTyped,
    StockManageListResVoToJSON,
    StockManageListResVoToJSONTyped,
} from './StockManageListResVo';

/**
 * 
 * @export
 * @interface PageDataStockManageListResVo
 */
export interface PageDataStockManageListResVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataStockManageListResVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataStockManageListResVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataStockManageListResVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<StockManageListResVo>}
     * @memberof PageDataStockManageListResVo
     */
    records?: Array<StockManageListResVo>;
}

/**
 * Check if a given object implements the PageDataStockManageListResVo interface.
 */
export function instanceOfPageDataStockManageListResVo(value: object): value is PageDataStockManageListResVo {
    return true;
}

export function PageDataStockManageListResVoFromJSON(json: any): PageDataStockManageListResVo {
    return PageDataStockManageListResVoFromJSONTyped(json, false);
}

export function PageDataStockManageListResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataStockManageListResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(StockManageListResVoFromJSON)),
    };
}

export function PageDataStockManageListResVoToJSON(json: any): PageDataStockManageListResVo {
    return PageDataStockManageListResVoToJSONTyped(json, false);
}

export function PageDataStockManageListResVoToJSONTyped(value?: PageDataStockManageListResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(StockManageListResVoToJSON)),
    };
}

